import type { Dispatch, PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import apiUrls from "../../../api";
import type { IContentType } from "../../../model/unityObject";
import type { RootState } from "../store";

export interface IPrettifiedContentType extends Omit<IContentType, "type"> {
  type: string;
  infoTitle?: string;
  infoText?: string;
}

export interface ICTState {
  list: IPrettifiedContentType[];
}

const initialState: ICTState = {
  list: [],
};

export const contentTypesSlice = createSlice({
  name: "contentTypes",
  initialState,
  reducers: {
    setCts: (state: ICTState, action: PayloadAction<IPrettifiedContentType[]>) => {
      state.list = [...action.payload];
    },
  },
});

export const { setCts } = contentTypesSlice.actions;

export const fetchCts = () => (dispatch: Dispatch) => {
  axios
    .get<IContentType[] | { data: IContentType[] }>(`${apiUrls.projects.contens.contentType}`)
    .then((res) => {
      const rows = Array.isArray(res.data) ? res.data : res.data.data;
      const response = rows.map((ct): IPrettifiedContentType => {
        // prettify "type" values (turning "_" into "-" ) so it can match our model names
        return {
          ...ct,
          type: String(ct.type).replace(/_/g, "-"),
          infoTitle: ct.title,
          infoText: ct.description,
        };
      });
      return dispatch(setCts(response));
    })
    .catch(console.error);
};

export const getCts = (state: RootState) => state.contentTypes.list;

export const contentTypesReducer = contentTypesSlice.reducer;
